import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/state/store'
import i18n from './i18n'
import apiClient from './api/adapter'
import utils from './utils'
import * as constants from './constants'

// 样式导入
import '@/assets/scss/app.scss'
import 'element-ui/lib/theme-chalk/index.css'
import 'sweetalert2/src/sweetalert2.scss'

// 第三方库导入
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import vco from 'v-click-outside'
import ElementUI from 'element-ui'
import VueEllipseProgress from 'vue-ellipse-progress'
import clipboard from 'clipboard'
import { 
  Stepper, 
  SubmitBar, 
  PasswordInput, 
  NumberKeyboard, 
  Toast, 
  Cell, 
  CellGroup, 
  Collapse, 
  CollapseItem, 
  RadioGroup, 
  Radio, 
  Divider, 
  Card 
} from 'vant'

const Base64 = require('js-base64').Base64
const Swal = require('sweetalert2')

// Vue配置
Vue.config.productionTip = false

// 全局属性注册
Vue.prototype.$axios = apiClient
Vue.prototype.$api = apiClient  // 别名
Vue.prototype.clipboard = clipboard
Vue.prototype.apiuri = ''  // 由于 apiClient 的 baseURL 已经是 /api，这里使用空字符串
Vue.prototype.version = process.env.version
Vue.prototype.$utils = utils
Vue.prototype.$constants = constants
Vue.prototype.Base64 = Base64
Vue.prototype.$swal = Swal

// 第三方插件注册
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(vco)
Vue.use(ElementUI)
Vue.use(VueEllipseProgress)

// Vant组件注册
Vue.use(PasswordInput)
Vue.use(NumberKeyboard)
Vue.use(Toast)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Divider)
Vue.use(Card)
Vue.use(Stepper)
Vue.use(SubmitBar)

// 全局组件注册
Vue.component('apexchart', VueApexCharts)


new Vue({
  router,
  store,
  i18n,
  data: function () {
    return {

      ismobile: false,
    }
  },
  render: h => h(App)
}).$mount('#app')
